import React from 'react';
import CapTooltip from '../../CapTooltip';
import { rootClsPrefix as clsPrefix } from '../constants';

export const Tooltip = ({ overlayClassName,...rest }) => {
  return <CapTooltip overlayClassName={`${clsPrefix}-tooltip-overlay ${overlayClassName}`} {...rest} />;
};
